import * as React from 'react';
import * as PropTypes from 'prop-types';
import IconWrapper from './IconWrapper';

const IconPatientAvatar = props =>
  React.createElement(
    IconWrapper,
    props,
    <svg
      viewBox="0 0 54 87"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className="block w-full h-full fill-current"
    >
      <path
        d="M52.19 47.43c-.196-11.023-4.422-15.371-11.844-16.572-1.054 8.146-4.655 17.357-7.092 22.868a15.173 15.173 0 00-4.091-.416c2.327-5.108 5.952-14.613 7.042-22.795l-13.914-.024C9.944 30.49 3.22 33.92 3.22 48.03l-.11 5.622A4.557 4.557 0 00.244 58.16v6.553a8.574 8.574 0 008.72 8.5h2.744v13.242h32.128l.074-4.214c5.255.319 8.733-1.335 9.137-6.688.564-7.349-.686-19.156-.857-28.122zm-38.216-1.114l3.111.098c-.073 2.241 0 4.997 0 6.896H14c-.062-1.923-.098-4.704-.025-6.994zM36.45 68.363a1.739 1.739 0 01-1.8 1.678H8.928a5.512 5.512 0 01-5.561-5.328V58.16c0-.93.453-1.69 1.458-1.69h24.68a9.652 9.652 0 014.57.919 4.507 4.507 0 012.375 4.348v6.626zm2.99 1.458a4.9 4.9 0 00.232-1.458v-6.626a8.574 8.574 0 00-1.017-4.201 6.787 6.787 0 01.784 12.248v.037zM14.317 14.3a13.963 13.963 0 1027.926 0 13.963 13.963 0 00-27.926 0z"
        fill="#4894EE"
      />
    </svg>,
  );
IconPatientAvatar.propTypes = {
  className: PropTypes.oneOfType([
    PropTypes.string,
    PropTypes.func,
    PropTypes.array,
    PropTypes.object,
  ]),
};
export default IconPatientAvatar;
